/** Conversion factor for converting radians to degrees. */
export const RAD_TO_DEG = 180 / Math.PI;

/** Conversion factor for converting degrees to radians. */
export const DEG_TO_RAD = Math.PI / 180;
